
import React from 'react';
import { StyledRowWrapper } from './styled';

const RowWrapper = ({ children }) => {
    return (
        <StyledRowWrapper>
            {children}
        </StyledRowWrapper>
    );
};

export default React.memo(RowWrapper);